<template>
  <div class="container-fluid mt-4" dir="rtl">
    
   


 <ControlFilters 
      title="كشوف مراجعة أرقام الجلوس"
      icon="fas fa-file-alt"
      :visible-filters="['admin','term','school','StudentType', 'DamgStatus', 'Moslem' , 'Nationality']"
      :loading="loading"
      @search="fetchReport"
      @print="printPage"
    />


    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="schoolsData.length > 0">
      
      <!-- حلقة تكرار لكل مدرسة -->
      <div v-for="(school, index) in schoolsData" :key="index" class="school-section" style="page-break-after: always;" dir="rtl">
        
        <!-- في حالة المدرسة ليس بها طلاب، لا تعرضها (أو اعرض رسالة) -->
        <div v-if="school.students && school.students.length > 0">
            
            <!-- ترويسة الصفحة -->
           

            

            <!-- جدول الطلاب -->
            <table class="table table-bordered border-dark text-center align-middle mb-0 custom-table">
                <thead class="bg-dark text-white">
                  <tr class="header-row border-0">
                    <th colspan="5" class="border-0 p-0">
                  <div class="report-header text-center mb-3 pt-2">
                <div class="row align-items-center">
                    <div class="col-4 text-start small">
                        <p class="m-0 fw-bold">مديرية التربية والتعليم</p>
                        <p class="m-0 fw-bold">لجنة النظام والمراقبة</p>
                    </div>
                    <div class="col-4">
                        <h4 class="fw-bold text-decoration-underline">كشف مراجعة أرقام الجلوس</h4>
                        <!-- <span class="badge border border-dark text-dark bg-white">{{ form.term == 'term1' ? 'الفصل الدراسي الأول' : 'الفصل الدراسي الثاني' }}</span> -->
                    </div>
                    <div class="col-4 text-end small">
                        <p class="m-0 fw-bold">قطاع / إدارة: {{ getAdminName(printOptions.admin) }}</p>
                        <p class="m-0 fw-bold">التاريخ: {{ new Date().toLocaleDateString('ar-EG') }}</p>
                    </div>
                </div>
                
                <!-- شريط اسم المدرسة -->
                <div class="mt-2 border border-dark bg-light p-2 rounded text-center">
                    <h5 class="m-0 fw-bold text-primary-dark">
                        مدرسة: {{ school.school_name }} 
                        <span class="ms-3 text-muted fs-6">(كود: {{ school.id }})</span>
                    </h5>
                </div>
            </div>
            </th>
            </tr>
                    <tr>
                       
                        <th width="15%">رقم الجلوس</th>
                        <th width="45%">اسم الطالب</th>
                        <th width="10%">الديانة</th>
                        <th width="10%">الجنسية</th>
                        <th width="15%">ملاحظات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(student, sIndex) in school.students" :key="student.id">
                  
                        <td class="fw-bold fs-5 font-monospace fs-23">{{ student.Seating_No }}</td>
                        <td class="text-start pe-3 fw-bold fs-23">{{ student.Arabic_Name }}</td>
                        <td>{{ student.Moslem_Name }}</td>
                        <td>{{ student.Nationality_Name }}</td>
                        <td>
                            <span class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-18" style="margin-top: 7px; background-color: gray; color: white;" v-if="student.Nationality != 1">مراجعة الجنسية</span>
                            <span class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-18" style="margin-top: 7px; background-color: gray; color: white;" v-else-if="student.Moslem != 1">مراجعة الديانة</span>
                            <span class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-18" style="margin-top: 7px; background-color: gray; color: white;" v-else-if="student.Damg_Status_id == 1">مراجعة الدمج</span>
                            <span v-else> </span>
                            </td> <!-- خانة فارغة للملاحظات اليدوية -->
                    </tr>
                </tbody>
                <tfoot class="bg-light fw-bold">
                    <tr>
                        <td colspan="2">عدد الطلاب: {{ school.students.length }}</td>
                        <td colspan="4" class="text-start ps-3">توقيع المراجع: ..............................</td>
                    </tr>
                </tfoot>
            </table>

            <!-- فاصل صفحات بعد كل مدرسة -->
            <div class="page-break"></div>
        </div>
      </div>

    </div>

    <!-- رسالة فارغة -->
    <div v-else-if="searched && !loading" class="alert alert-warning text-center mt-4 no-print">
        لا توجد بيانات للعرض، تأكد من اختيار الإدارة أو المدرسة.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import ControlFilters from '@/components/ControlFilters.vue';
export default {
    components: { ControlFilters },
  name: "SeatingReviewReport",
  data() {
    return {
      loading: false,
      searched: false,
      schoolsData: [], 
      
      administrations: [], 
    //   schoolsList: [],     
printOptions:{
    admin_id:'',
},
      form: {
        admin_id: "",
        school_id: "",
        term: "term1"
      }
    };
  },
  mounted() {
    // جلب الإدارات عند التحميل
    this.fetchAdmins();
  },
  methods: {
    async fetchAdmins() {
        // استبدل بالرابط الحقيقي
        // const res = await api.get('/admin/administrations');
        // this.administrations = res.data;
        
        
        this.administrations = [
            { id: 1, name: 'العريش' }, { id: 2, name: 'بئر العبد' }
        ];
    },

    // async fetchSchools() {
    //     this.form.school_id = ""; // تصفير المدرسة القديمة
    //     this.schoolsList = [];
    //     if(!this.form.admin_id) return;

    //     try {
    //         // جلب مدارس الإدارة المختارة لملء القائمة
    //         const res = await api.get(`/admin/schools?admin_id=${this.form.admin_id}`);
    //         this.schoolsList = res.data;
    //     } catch (e) { console.error(e); }
    // },


    fetchReport(filters) {

      this.loading = true;
      this.printOptions = filters;
  this.schoolsData = [];
            api.post('/admin/reports/seating-review',  filters )
            .then(res => this.schoolsData = res.data)
            .finally(() => this.loading = false).catch((e) => {});
    },



    // async fetchReport() {
    //     if(!this.form.admin_id) return alert("اختر الإدارة على الأقل");

    //     this.loading = true;
    //     this.searched = true;
    //     this.schoolsData = [];

    //     try {
    //         const res = await api.get('/admin/reports/seating-review', { params: this.form });
    //         this.schoolsData = res.data;
    //     } catch (e) {
    //         console.error(e);
    //         alert("حدث خطأ");
    //     } finally {
    //         this.loading = false;
    //     }
    // },

    getAdminName(id) {
        const admin = this.administrations.find(a => a.id == id);
        return admin ? admin.name : '';
    },

    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }

@media print {
    .no-print { display: none !important; }
    #printMe { visibility: visible; }
    
    /* فاصل الصفحات */
    .school-section {
        page-break-after: always;
        page-break-inside: avoid;
    }
    
    /* تكرار الهيدر في الجدول الطويل */
    thead { display: table-header-group; }
    tr { page-break-inside: avoid; }

    /* تنسيق الجدول */
    .custom-table th, .custom-table td {
        border: 1px solid #000 !important;
        font-size: 13pt;
        padding: 5px;
    }
    
    /* الألوان */
    .bg-dark { background-color: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
    .bg-light { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
    .text-primary-dark { color: #000 !important; font-weight: 900; }
}
</style>